import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';
import ReCAPTCHA from 'react-google-recaptcha';

const WelcomeScreen = ({
  setScreenNumber,
  handleNextScreen,
  telegramLink,
  onTelegramHandleClick,
  isPartner = false
}) => {
  const [captchaPassed, setCaptchaPassed] = useState(false);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleCaptchaChange = useCallback((token) => {
    setCaptchaPassed(!!token);
  }, []);

  const handleCaptchaExpired = useCallback(() => {
    setCaptchaPassed(false);
  }, []);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
          onTelegramHandleClick={onTelegramHandleClick}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>
          Вітаємо у<br></br>
          діджитальному<br></br>
          світі компанії<br></br>
          Філіп Морріс!
        </p>
        {isPartner ? (
          <p className={styles.description}>
            Реєструйся на платформі, проходь<br></br>
            опитування та залишайся на звʼязку<br></br>
            зі своїм брендом.
          </p>
        ) : (
          <p className={styles.description}>
            Реєструйся на платформі, проходь<br></br>
            коротке опитування та отримуй<br></br>
            поповнення мобільного рахунку на 30<br></br>
            гривень за витрачений час.
          </p>
        )}
        <div className={styles.buttonContainer}>
          {siteKey && (
            <div style={{ marginBottom: 16, width: '100%' }}>
              <ReCAPTCHA
                sitekey={siteKey}
                size="normal"
                onChange={handleCaptchaChange}
                onExpired={handleCaptchaExpired}
              />
            </div>
          )}
          <button
            className={styles.nextButton}
            onClick={handleNextScreen}
            disabled={siteKey ? !captchaPassed : false}
          >
            Далі
          </button>
        </div>
        {/*<button className={styles.skipButton}>Пропустити</button>*/}
      </div>
      <div className={styles.footer}>
        Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
        компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
        частини 2 статті 15 Закону «Про захист прав споживачів» та підтверджуєш,
        що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ ПРИСТРОЇВ ДЛЯ
        СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
      </div>
    </div>
  );
};

export default WelcomeScreen;
